import {JSX, ReactNode} from 'react'
import {cn} from "../../utils/helper";

type HeadingSize = 'display' | 'h1' | 'h2' | 'h3' | 'subtitle' | 'body'

export interface HeadingProps {
    as?: keyof JSX.IntrinsicElements
    size?: HeadingSize
    children: ReactNode
    className?: string
}

const sizeMap: Record<HeadingSize, string> = {
    display:
        'text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900',
    h1: 'text-2xl sm:text-[47px] font-[700] tracking-tight text-black',
    h2: 'text-xl sm:text-2xl font-semibold text-gray-900',
    h3: 'text-lg sm:text-xl font-semibold text-gray-900',
    subtitle: 'text-[16px] sm:text-lg text-black',
    body: 'text-base text-gray-700',
}

export function Heading({
                            as: Tag = 'h2',
                            size = 'h2',
                            children,
                            className,
                        }: HeadingProps) {
    return <Tag className={cn(sizeMap[size], className)}>{children}</Tag>
}
